<template>
  <template v-if="pageListChild == 'machinefailrate'">
    <!-- 機台故障率 -->
    <machineFailRate></machineFailRate>
  </template>
  <template v-else-if="pageListChild == 'machinefailtime'">
    <!-- 機台故障時間 -->
    <machineFailTime></machineFailTime>
  </template>
</template>

<script>
import machineFailRate from "@/components/statisticalReports/failStatistics/machineFailRate";
import machineFailTime from "@/components/statisticalReports/failStatistics/machineFailTime";
import { inject } from "vue";
export default {
  components: {
    machineFailRate,
    machineFailTime,
  },
  setup() {
    const pageListChild = inject("pageListChild");

    return {
      pageListChild,
    };
  },
};
</script>

<style></style>
